<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa240-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]" @btnRetrieve="btnRetrieve()" @btnExcel="onExporting()">

                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Cutter : </span>
                          <v-col cols="1">
                            <v-select
                              v-model="cutMaker"
                              :items="cutMakerList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              outlined
                              dense
                              height="32"
                            />
                          </v-col>

                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-2 pr-0"> Division: </span>
                          <v-col cols="2">
                            <v-select
                              v-model="rptDiv"
                              :items="rptDivList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                        
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-2 pr-0"> Period : </span>
                          <v-col cols="1">
                              <DxDateBox :value="stDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              @value-changed="e => {stDate = e.value && getStrFormat(e.value)}" />
                          </v-col>
                          <span class="pa-2"> ~ </span>
                          <v-col cols="1" class="pl-0">
                              <DxDateBox :value="edDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              @value-changed="e => {edDate = e.value && getStrFormat(e.value)}" />
                          </v-col>
                        
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Ship No. : </span>
                          <v-col cols="1">
                              <v-select
                                v-model="shipNo"
                                :items="shipNoList"
                                item-value="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                                label="Select"
                                @change="getBlock()"
                              ></v-select>
                          </v-col>
                        
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Block : </span>
                          <v-col cols="1">
                            <v-select
                              v-model="block"
                              :items="blockList"
                              single-line
                              outlined
                              dense
                              height="32"
                            />
                          </v-col>

                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epmsa240" 
                    class="listBox" 
                    :ref="epmsa240Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @exporting="onExporting"                                    
                  >
                    <DxExport :enabled="true" />
                    <DxPaging :enabled="false" />
                    <DxPager :visible="false" />

                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="DRAWING" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="shipNo" caption="Ship" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="lotNo" caption="Lot No" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="cutGrp" caption="Group" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="pcsQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                      <DxColumn data-field="pcsWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>
                    
                    <DxColumn caption="CUTTING" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="cutDte" caption="Date" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="cutQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="cutWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="CUT CONFIRM" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="cnfDte" caption="Date" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="cnfQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="cnfWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="REQUEST ASSY" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="reqDte" caption="Date" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="reqQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="reqWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="DELIVERY" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="dlyDte" caption="Date" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="dlyQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="dlyWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn data-field="cutMakerNm" caption="Cutting Maker" width="5%" data-type="string" alignment="center" header-cell-template="cutMakerNmTemp" :allow-editing="false"/>
                    <template #cutMakerNmTemp>
                      <div> Cutting<br>Maker</div>
                    </template>

                    <DxSummary>
                      <DxTotalItem column="shipNo" summary-type="count" display-format="TOTAL" />
                      <DxTotalItem column="pcsQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="pcsWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="cutQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="cutWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="cnfQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="cnfWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="reqQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="reqWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="dlyQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="dlyWgt" summary-type="sum" :customize-text="totalFormat" />
                    </DxSummary>
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxExport,
    DxLookup,
    DxSelection,
    DxPager
} from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epmsa240, epmsa240Xls, getCutMakerList, getBlockList } from '@/api/view/hip/A/epmsa240'
import { getShipNoList} from '@/api/view/hip/A/epmsa010_kl'
import { getNumComma, toNum } from '@/utils/common.js'
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getCmChildCode } from '@/api/system/cmCodeManage'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epmsa240',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxExport,
    DxLookup,
    DxSelection,
    DxPager
},

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel'],
      epmsa240Ref: 'epmsa240Ref',
      gridMainList: [],
      shipNoList: [],
      makerCd: this.$store.state.user.makerCd,
      shipNo: '',
      block: '',
      blockList: [],
      cutMaker: '',
      cutMakerList: [],
      stDate: null,
      edDate: null,
      rptDiv: '',
      rptDivList: [],
      format: '#,##0.##',
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa240Ref)
    },
  },
  mounted() {
    this.init()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.getList() 
    //this.btnRetrieve()
  },
  methods: {
    totalFormat(e) {
        const result = getNumComma(Number(e.value.toFixed(2)), 2)
        return result
    },
    getStrFormat(date) {
        return getDateFormat(date)
    },
    init() {
        this.gridInstance.option('defaultPaging', false)
        let toDay = new Date
        this.stDate = toDay.setDate(toDay.getDate() - 7);
        //console.log(this.stDate) ;

        toDay = new Date
        this.edDate = toDay.setDate(toDay.getDate());

        this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
        this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

        this.getList()
    },
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          code: '',
          codegr: '',
          prtCode: 'CUT_RPT_DIV',
          userFlag: 'Y'
        }
        await getCmChildCode(params).then(res => {
          this.rptDivList = res.list
          this.rptDiv     = res.list[0]
        })

        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })

        await getCutMakerList(param).then(res => {
          this.cutMakerList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.cutMakerId
            e.codeName = !e.cutMakerNm ? '' : e.cutMakerNm 
            this.cutMakerList.push(e)
          });

          if(this.makerCd ==='11951') {
            this.cutMaker = this.cutMakerList[1];
          }else {
            this.cutMaker = this.cutMakerList[2];
          } ;
        
        })

      } finally {
      this.endLoading()
      }
    },
    async getBlock(){
      let param = {
        shipNo: this.shipNo
      }
      this.openLoading('searching')
      await getBlockList(param).then(res => {
        this.blockList = []
        this.blockList.push('')
        res.list.forEach(e => {
          this.blockList.push(e.block)
        });
        this.block = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },

    async getMainList(){
      this.gridMainList = []
      try {
        this.openLoading('searching')
        let params = {
          shipNo : this.shipNo,
          block: this.block,
          cutMakerId: this.cutMaker.code,
          stDte: this.stDate,
          edDte: this.edDate,
          rptDiv: this.rptDiv.code
        }
        console.log(params)
        await epmsa240(params).then(res => {
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            list.push(
              {
                id: cnt++ , rnum: e.rnum,  shipNo: e.shipNo, lotNo: e.lotNo, cutGrp: e.cutGrp, pcsQty: e.pcsQty,  pcsWgt: e.pcsWgt, 
                cutDte: e.cutDte, cutQty : e.cutQty, cutWgt : e.cutWgt,
                cnfDte: e.cnfDte, cnfQty : e.cnfQty, cnfWgt : e.cnfWgt,
                reqDte: e.reqDte, reqQty : e.reqQty, reqWgt : e.reqWgt,
                dlyDte: e.dlyDte, dlyQty : e.dlyQty, dlyWgt : e.dlyWgt,
                cutMakerNm: e.cutMakerNm
              }
            )
          });
          console.log(list)
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    // btnExcel(){
    //   this.openLoading('searching')
    //   // const param = {
    //   //     shipNo : this.shipNo,
    //   //     block: this.block,
    //   //     cutMakerId: this.cutMaker.code,
    //   //     stDte: this.stDate,
    //   //     edDte: this.edDate,
    //   //     rptDiv: this.rptDiv.code
    //   // }
    //   // epmsa240Xls(param)
    //   this.onExporting() 
    //   this.endLoading()
    // },
    onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('sheet');

        exportDataGrid({
            component: this.gridInstance,
            worksheet,
            topLeftCell: { row: 4, column: 1 },
        }).then((cellRange) => {

            // header
            const titleRow = worksheet.getRow(2);
            titleRow.height = 30;
            worksheet.mergeCells(2, 1, 2, 19);

            titleRow.getCell(1).value = 'Cutting Result Follow Up (Deahyup VN)';
            titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 22, bold: true };
            titleRow.getCell(1).alignment = { horizontal: 'center' , vertical: 'middle' } ;

            // condition
            const condRow = worksheet.getRow(3);
            condRow.height = 20;
            worksheet.mergeCells(3, 1, 3, 19);

            let strCond = 'Cutting duration: ' + this.stDate + ' ~ ' + this.edDate;
            condRow.getCell(1).value = strCond;
            condRow.getCell(1).font = { name: 'Calibri', size: 12, bold: true };
            condRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };

            const headerRow = worksheet.getRow(4);
            const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
            const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, top: {style: 'thin', fgColor: { argb: 'bfbfbf' }}, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
            let headerRowLength = headerRow._cells.length       

            for(let i = 4; i <= headerRowLength; i++){
              headerRow.getCell(i).fill = headerStyle
              headerRow.getCell(i).border = headerBorderStyle
              headerRow.getCell(i).alignment = { horizontal: 'center', vertical: 'middle' }
            }

            for(let j = 4; j <= worksheet._rows.length; j++){
              for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){

                  if (j == 4 || j == 5) {
                    worksheet.getRow(j).getCell(a).fill = headerStyle
                  }
                  worksheet.getRow(j).getCell(a).border = headerBorderStyle
                  
                  // if(worksheet.getColumn(a).dataField == "useQty" || worksheet.getColumn(a).dataField == "woQty") {
                  //     worksheet.getRow(j).getCell(a).format = "#,###"
                  //     worksheet.getRow(j).getCell(a).alignment = { horizontal: 'right' }
                  // }
              }
            }
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CuttingResult.xlsx');
            });
        });     

        this.gridInstance.cancel = true;
      },
  }
}
</script>
<style lang="scss" scoped>
.epmsa240-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }
}
</style>